import {
  Box,
  Button,
  FormControl,
  Flex,
  Heading,
  Input,
  Stack,
  Text,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import { Header } from '../Header';
import { Footer } from '../Footer';

type ForgotPasswordFormInputs = {
  email: string;
};

// TODO move to utils
function checkEmail (email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export default function ForgotPasswordForm(): JSX.Element {

  const [userEmail, setUserEmail] = useState('');
  const toast = useToast();

  const submitForgotPassword = async event => {

    if (!checkEmail(userEmail)) {
      toast({
                title: `Valid email address required`,
                status: 'error', isClosable: true,
            })
      return;
    }

    let data = {
      email: userEmail
    };

    fetch("/api/forgot-password", {
      method: "POST",
      credentials: 'include',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(data)
    })
    .then(response => {
      if (response.status == 200) {
        toast({
                  title: `Check your email`,
                  status: 'info', isClosable: true,
              })
      }
    });
  };

  return (
    <Box>
    <Header hide_sign_in={true} />
    <Flex
      minH={'50vh'}
      align={'center'}
      justify={'center'}>
      <Stack
        spacing={4}
        w={'full'}
        maxW={'md'}
        bg={useColorModeValue('white', 'gray.700')}
        rounded={'xl'}
        boxShadow={'lg'}
        p={6}
        my={12}>
        <Heading lineHeight={1.1} fontSize={{ base: '2xl', md: '3xl' }}>
          Forgot your password?
        </Heading>
        <Text
          fontSize={{ base: 'sm', sm: 'md' }}
          color={useColorModeValue('gray.800', 'gray.400')}>
          You&apos;ll get an email with a reset link
        </Text>
        <FormControl id="email">
          <Input
            onChange={(e) => setUserEmail(e.target.value) }
            placeholder="your-email@example.com"
            _placeholder={{ color: 'gray.500' }}
            type="email"
          />
        </FormControl>
        <Stack spacing={6}>
          <Button
            onClick={submitForgotPassword}
            bg={'blue.400'}
            color={'white'}
            _hover={{
              bg: 'blue.500',
            }}>
            Request Reset
          </Button>
        </Stack>
      </Stack>
    </Flex>
    <Footer/>
    </Box>
  );
}
